module.exports = __webpack_public_path__ + "img/t2.4c2c2d2f.png";